import React, { useState } from 'react'
import axios  from "../../../../../Global/axios";
import { useDispatch } from 'react-redux';
import { setAppError } from '../../../../../store/userSlice';




const GovPortalForm = ({ openGovForm, setOpenGovForm, setUpdateVrfData }) => {
  const [sumbmitLoading, setSubmitLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [visaQuantityError,setVisaQuantityError] = useState("")


  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    
    const VrfId = openGovForm.vrfId;
    const sadad_number = e.target.sadad_number.value;
    const visa_quantity = e.target.gr_requested_visa_quantity.value;
  
    const body = {
      status: "started_visa_process_in_gov_portal",
      gr_requested_visa_quantity: visa_quantity,
      sadad_number: sadad_number,
    };
    if (sadad_number != "" && visa_quantity != "") {
      if (Number(openGovForm?.reqVisaQuantity) <= Number(visa_quantity)) {
        setVisaQuantityError("");
        try {
          const response = await axios.post(
            `/dashboard/gr-visa-vrf/status-update/${VrfId}`,
            body,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (response.status === 200) {
            setSubmitLoading(false);
            dispatch(
              setAppError({
                msg: response.data.message,
                color: "bg-green-600",
              })
            );
            setOpenGovForm({ open: false, vrfId: "", reqVisaQuantity: "" });
            setUpdateVrfData((prev) => !prev);
          }
        } catch (e) {
          setSubmitLoading(false);
          dispatch(setAppError({ msg: e.response.data.message }));
          setVisaQuantityError(e.response.data.message);
        }
      } else {
        setSubmitLoading(false);
        setVisaQuantityError(
          "The requested quantity of VISA is less than the actual VISA quantity needed"
        );
        return;
      }
      
    }
  };
  return (
    <form
      onSubmit={submitHandler}
      className={`fixed z-50 top-0 left-0 min-w-full uppercase min-h-screen bg-black/50  justify-center items-center ${
        openGovForm ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-2xl w-full h-auto  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col">
        <h2 className="text-2xl p-4 pb-1 text-center">VISA GOV Process</h2>

        <div className="mt-8 mb-4">
          <label className="block mb-2 font-medium" htmlFor="">
            SADAD Number
          </label>
          <input
            type="number"
            name="sadad_number"
            className="input uppercase input-sm"
            placeholder="Enter SADAD Number"
            required
          />
        </div>
        <div className="mb-8">
          <label className="block uppercase mb-2 font-medium" htmlFor="">
            Visa Quantity
          </label>
          <input
            type="number"
            name="gr_requested_visa_quantity"
            placeholder="Enter Visa Quantity"
            className="input input-sm"
            required
          />
        </div>
        {visaQuantityError != "" && <p className='bg-pink-100 text-red px-2 text-sm'>{visaQuantityError}</p>}

        <div className="flex gap-3 min-w-fit m-5">
          <button
            className="p-1 w-20 uppercase rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setOpenGovForm(false);
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="p-1 w-fit px-2 uppercase rounded-md ring-1 ring-red text-white bg-red"
          >
            {sumbmitLoading ? "Submiting.." : "Submit"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default GovPortalForm